import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface BulkUpdateSupplierDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  affectedCount: number;
  supplierName: string;
  onConfirm: () => void;
  onSkip: () => void;
  isApplying: boolean;
}

export const BulkUpdateSupplierDialog: React.FC<BulkUpdateSupplierDialogProps> = ({
  open,
  onOpenChange,
  affectedCount,
  supplierName,
  onConfirm,
  onSkip,
  isApplying,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Leverancier bijwerken</DialogTitle>
          <DialogDescription>
            De leverancier voor dit type is gewijzigd naar <strong>{supplierName}</strong>.
            Wil je ook de leverancier bijwerken voor{' '}
            <strong>{affectedCount}</strong> bestaande onderhoudsschema&apos;s
            in de betreffende clusters?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button
            variant="outline"
            onClick={onSkip}
            disabled={isApplying}
          >
            Alleen voor nieuwe
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isApplying}
          >
            {isApplying ? 'Bijwerken...' : 'Bijwerken'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
